import React from "react";

export default function PrivacyPolicy() {
  return (
    <div className="privacy-page">
  <style>
 {`
    .privacy-page {
      background-color: white;
      color: black;
      min-height: 100vh;
      padding: 60px 200px;
      font-family: Arial, sans-serif;
      text-align: left;
    }

    .privacy-header {
      display: flex;
      align-items: center;
      gap: 15px;
      margin-bottom: 40px;
    }

    .privacy-header img {
      width: 40px;
      height: 40px;
    }

    .privacy-header h1 {
      font-size: 28px;
      font-weight: bold;
      color: black;
      margin: 0;
    }

    .privacy-section {
      margin-bottom: 30px;
    }

    .privacy-section h4 {
      font-size: 20px;
      font-weight: bold;
      margin-top: 25px;
      margin-bottom: 5px;
      color: black;
      line-Height:0.8;
    }

    .privacy-section p,
    .privacy-section li {
      font-size: 16px;
      color: black;
      line-height: 1.4;
      margin-top: 5px;
      margin-bottom: 10px;
    }

    .privacy-section ul {
      padding-left: 20px;
    }

    @media (max-width: 768px) {
      .privacy-page {
        padding: 40px 30px;
      }

      .privacy-header h1 {
        font-size: 22px;
      }

      .privacy-section p,
      .privacy-section li {
        font-size: 15px;
      }
    }`}
  </style>

  <div className="privacy-header">
    {/* <img src="your-icon.png" alt="Privacy Icon" /> */}
    <h1>🔐 Privacy Policy for Dispatchers</h1>
  </div>

  <div className="privacy-content" style={{lineHeight:1, maxWidth:'100%'}}>
    <div className="privacy-section">
      <h4>1. Introduction</h4>
      <p>
        This Privacy Policy explains how we collect, use, and protect the
        personal information of dispatchers who use our app. By using the
        app, you agree to the terms outlined here.
      </p>
    </div>

    <div className="privacy-section">
      <h4>2. Information We Collect</h4>
      <ul>
        <li><strong>Personal Information:</strong> Name, phone number, email address, and ID documents (if required).</li>
        <li><strong>Location Data:</strong> Real-time GPS location for delivery tracking and route optimization.</li>
        <li><strong>Device Information:</strong> Device model, OS, app version, and network status.</li>
        <li><strong>Usage Data:</strong> App interactions, delivery history, and performance metrics.</li>
      </ul>
    </div>

    <div className="privacy-section">
      <h4>3. How We Use Your Information</h4>
      <ul>
        <li>Match you with delivery opportunities</li>
        <li>Track and display your location to clients during deliveries</li>
        <li>Monitor performance and improve service quality</li>
        <li>Communicate important updates or alerts</li>
        <li>Comply with legal and regulatory requirements</li>
      </ul>
    </div>

    <div className="privacy-section">
      <h4>4. Data Sharing</h4>
      <p>We do not sell your personal data. However, we may share limited information with:</p>
      <ul>
        <li><strong>Clients:</strong> For delivery coordination and tracking</li>
        <li><strong>Legal Authorities:</strong> If required by law or in case of investigation</li>
        <li><strong>Service Providers:</strong> For app operations (e.g., hosting, analytics)</li>
      </ul>
    </div>

    <div className="privacy-section">
      <h4>5. Your Responsibilities</h4>
      <p>
        You must ensure that the information you provide is accurate and up to date.
        You must not misuse the app or attempt to bypass location tracking or verification.
      </p>
    </div>

    <div className="privacy-section">
      <h4>6. Data Security</h4>
      <p>
        We implement reasonable security measures to protect your data from unauthorized access or disclosure.
        However, no system is 100% secure, and we cannot guarantee absolute protection.
      </p>
    </div>

    <div className="privacy-section">
      <h4>7. Retention</h4>
      <p>
        We retain your data for as long as necessary to fulfill the purposes outlined in this policy or as required by law.
      </p>
    </div>

    <div className="privacy-section">
      <h4>8. Your Rights</h4>
      <p>Depending on your jurisdiction, you may have rights to:</p>
      <ul>
        <li>Access your personal data</li>
        <li>Request corrections or deletion</li>
        <li>Withdraw consent for certain types of data processing</li>
      </ul>
      <p>To exercise these rights, contact us at [Insert Contact Email].</p>
    </div>

    <div className="privacy-section">
      <h4>9. Changes to This Policy</h4>
      <p>
        We may update this Privacy Policy periodically. Continued use of the app after updates
        implies acceptance of the new terms.
      </p>
    </div>

    <div className="privacy-section">
      <h4>10. Contact Us</h4>
      <p>
        If you have questions or concerns about this Privacy Policy, please reach out to us.
      </p>
    </div>
  </div>
</div>

  );
}
